import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { SelectButton, Dropdown } from "@weezevent/nacre";
import {
	INACTIVE_STATUS,
	ACTIVE_STATUS,
	ARCHIVE_STATUS
} from "models/checkpoint";
import classes from "./checklists-batchs-actions.module.scss";
import { ChecklistsBatchActionsModals } from "./batch-actions-modals";
import {
	PARTICIPATION,
	SCAN,
	SCAN_FAILED,
	CHECKPOINTS
} from "actions/api/exports/actions";

const ChecklistsBatchActions = ({
	selectedCheckpoints,
	canEdit,
	onChangeStatus,
	onSuccess,
	selectedCheckpointsStatuses,
	onExport,
	canManage,
	hasEvents
}) => {
	const { t } = useTranslation();
	const [openedModal, setOpenedModal] = React.useState(null);

	const handleExport = procss => onExport(procss);

	const handleSuccessBatchAction = () => {
		onSuccess();
		setOpenedModal(null);
	};

	return (
		<>
			<ChecklistsBatchActionsModals
				openedType={openedModal}
				onCancel={() => setOpenedModal(null)}
				onSuccess={handleSuccessBatchAction}
				checklistsIds={selectedCheckpoints}
				selectedCheckpointsStatuses={selectedCheckpointsStatuses}
			/>
			<SelectButton
				tooltipTitle={t("access.checkpoint.filterset.noActionTooltip")}
				title={
					selectedCheckpoints.length > 0
						? t("access.checkpoint.checkpointSelected", {
								count: selectedCheckpoints.length
						  })
						: t("access.checkpoint.filterset.noAction")
				}
				isValid={selectedCheckpoints.length > 0}
				objects={selectedCheckpoints}
			>
				<span className={classes.title}>
					{t("access.checkpoint.batchChecklists.export")}
				</span>
				<Dropdown.Item
					key={PARTICIPATION}
					onClick={() => handleExport(PARTICIPATION)}
					item={t("access.checkpoint.actions.participationLabel")}
				/>
				<Dropdown.Item
					key={SCAN}
					onClick={() => handleExport(SCAN)}
					item={t("access.checkpoint.actions.scanLabel")}
				/>
				<Dropdown.Item
					key={SCAN_FAILED}
					onClick={() => handleExport(SCAN_FAILED)}
					item={t("access.checkpoint.actions.failedScanLabel")}
				/>
				<Dropdown.Item
					key={CHECKPOINTS}
					onClick={() => handleExport(CHECKPOINTS)}
					item={t("access.checkpoint.actions.exportListing")}
				/>
				<Dropdown.Line />
				<span className={classes.title}>
					{t("access.checkpoint.batchChecklists.checklistsStates")}
				</span>
				<Dropdown.Item
					key="1.0"
					disabled={!canEdit}
					onClick={() => onChangeStatus(ACTIVE_STATUS)}
				>
					{t("access.checkpoint.actions.active")}
				</Dropdown.Item>
				<Dropdown.Item
					key="1.1"
					disabled={!canEdit}
					onClick={() => onChangeStatus(INACTIVE_STATUS)}
				>
					{t("access.checkpoint.actions.inactive")}
				</Dropdown.Item>
				<Dropdown.Item
					key="1.2"
					disabled={!canEdit}
					onClick={() => onChangeStatus(ARCHIVE_STATUS)}
				>
					{t("access.checkpoint.actions.archivedLabel")}
				</Dropdown.Item>
				<Dropdown.Line />
				<span className={classes.title}>
					{t("access.checkpoint.actions.weezTagHeader")}
				</span>
				<Dropdown.Item
					key="2.0"
					disabled={!canEdit}
					onClick={() => setOpenedModal("LINK_WEEZ_TAG_MODAL")}
				>
					{t("access.checkpoint.actions.weezTagChecklists")}
				</Dropdown.Item>
				{canEdit && hasEvents && canManage && (
					<>
						<Dropdown.Line />
						<span className={classes.title}>
							{t(
								"access.checkpoint.batchChecklists.accessEventConfiguration"
							)}
						</span>
						<Dropdown.Item
							key="3.0"
							disabled={!canEdit}
							onClick={() =>
								setOpenedModal("DUPLICATE_CHECKLISTS_MODAL")
							}
						>
							{t("access.checkpoint.actions.duplicateChecklists")}
						</Dropdown.Item>
					</>
				)}
			</SelectButton>
		</>
	);
};

ChecklistsBatchActions.propTypes = {
	selectedCheckpoints: PropTypes.arrayOf(PropTypes.any).isRequired,
	canEdit: PropTypes.bool.isRequired,
	onChangeStatus: PropTypes.func.isRequired,
	onSuccess: PropTypes.func.isRequired,
	selectedCheckpointsStatuses: PropTypes.arrayOf(PropTypes.any).isRequired,
	onExport: PropTypes.func.isRequired,
	canManage: PropTypes.bool.isRequired,
	hasEvents: PropTypes.bool.isRequired
};

export default ChecklistsBatchActions;
